export default "__VITE_ASSET__BI9w3VkZ__"